<div class="loader-wrapper">
    <app-loader [isBusy]="isBusy">
        <ng-template>
            <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button class="close" type="button" aria-label="Close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col">
                        <kendo-grid
                            [data]="itemsGridView"
                            [skip]="itemPage.skip"
                            [pageSize]="itemPage.pageSize"
                            [pageable]="pagingOptions"
                            [sortable]="{ allowUnsort: allowUnsort, mode: multiple ? 'multiple' : 'single' }"
                            [sort]="sort"
                            [resizable]="true"
                            (pageChange)="pageChange($event, documents)"
                            (sortChange)="sortChange($event, documents)">
                            <kendo-grid-column field="id" title="{{ 'Doc Number' | translate }}" [width]="100">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    @if (!hasPermission('TosOperations.StorageDocument.Search')) {
                                        <span>
                                            {{ dataItem.id }}
                                        </span>
                                    }
                                    @if (hasPermission('TosOperations.StorageDocument.Search')) {
                                        <a
                                            class="row-link"
                                            (click)="navigateToDocument(dataItem.id, dataItem.isAmendmentDocument)">
                                            {{ dataItem.id }}
                                        </a>
                                    }
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-column
                                field="typeId"
                                title="{{ 'Type' | translate }}"
                                [width]="100"></kendo-grid-column>

                            <kendo-grid-column field="status.id" title="{{ 'Status' | translate }}" [width]="100">
                                <ng-template kendoGridCellTemplate let-row>
                                    <span class="pill" [ngClass]="getStatusClass(row.status.id)">
                                        {{ row.status.localizedCode }}
                                    </span>
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-column title="{{ 'Quantity' | translate }}" field="numberOfUnits" [width]="100">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    {{ dataItem.numberOfUnits || '' }}
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-column
                                title="{{ 'Gross Weight (kg)' | translate }}"
                                field="grossWeight"
                                [width]="150"
                                [style]="{ 'text-align': 'right' }">
                                <ng-template kendoGridCellTemplate let-row>
                                    {{ row.grossWeight | cargoAmount: '1.3-3' : 'de' }}
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-column
                                title="{{ 'Net Weight (kg)' | translate }}"
                                field="nettWeight"
                                [width]="150"
                                [style]="{ 'text-align': 'right' }">
                                <ng-template kendoGridCellTemplate let-row>
                                    {{ row.nettWeight | cargoAmount: '1.3-3' : 'de' }}
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-column
                                title="{{ 'Volume' | translate }}"
                                field="volume"
                                [width]="100"
                                [style]="{ 'text-align': 'right' }">
                                <ng-template kendoGridCellTemplate let-row>
                                    {{ row.volume | cargoAmount: '1.3-3' : 'de' }}
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-column
                                field="completedByFullName"
                                title="{{ 'Completed By' | translate }}"
                                [width]="150"></kendo-grid-column>

                            <kendo-grid-column
                                field="completedDate"
                                title="{{ 'Completed Date' | translate }}"
                                [width]="130">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    {{ dataItem.completedDate | date: 'dd.MM.yyyy HH:mm' }}
                                </ng-template>
                            </kendo-grid-column>

                            <ng-template kendoGridNoRecordsTemplate>
                                <p>{{ 'No records available' | translate }}.</p>
                            </ng-template>
                        </kendo-grid>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn btn-sm btn-danger" type="button" (click)="close()">
                    {{ 'Close' | translate }}
                </button>
            </div>
        </ng-template>
    </app-loader>
</div>
